<template>
  <v-container fluid>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div class="pt-5 pl-md-5 pb-10" style="max-width: 1000px" v-if="!loading">
      <div
        v-if="!archivedListings.length && !listProperty.length && !waitDialog"
        class="text-center"
      >
        <v-alert border="left" colored-border type="light-blue" elevation="1"
          >No properties found.<br />
          <v-btn to="/listing/add" rounded color="light-blue ma-5" dark
            ><v-icon size="small" class="mr-2">mdi-home-plus-outline</v-icon
            >{{ $t("AddNewProperty") }}
          </v-btn>
        </v-alert>
      </div>
      <div v-if="listProperty.length" class="pl-md-3">
        <h1 class="text-h5 mb-5 mt-5">
          {{ $t("Listofproperties") }}
          <v-btn to="/listing/add" color="light-blue ma-5" dark
            >{{ $t("AddNewProperty") }}
          </v-btn>
        </h1>
        <v-row
          class="elevation-1 mb-5 white"
          v-for="item in listProperty"
          :key="item._id"
        >
          <v-col cols="12" md="3">
            <v-skeleton-loader
              v-if="!item.pictures.length"
              class="mx-auto"
              type="image"
              height="180"
            ></v-skeleton-loader>
            <v-carousel
              show-arrows-on-hover
              hide-delimiters
              class
              height="180"
              v-if="item.pictures.length"
            >
              <v-carousel-item
                v-for="(items, i) in item.pictures"
                :key="i"
                :src="
                  $store.state.baseUrl +
                    'listing/thumb320x240-' +
                    items.file_name
                "
              ></v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col cols="12" md="9">
            <div class="pb-2">
              <v-chip
                v-if="!item.active"
                small
                class="mr-2"
                color="red"
                text-color="white"
              >
                {{ $t("Inactive") }}
              </v-chip>
              <v-chip
                small
                v-if="item.active"
                class="mr-2"
                color="green"
                text-color="white"
              >
                {{ $t("Active") }}
              </v-chip>
              <v-chip small class="mr-2" color="yellow">
                {{ $t("Created") }} :
                {{ format(new Date(item.dateCreated), "MM/dd/yyyy") }}
              </v-chip>
            </div>
            <div class="text-h5">
              {{ item.name }}
            </div>
            <div class="subtitle-1 pt-1 text-capitalize">
              <span>
                <v-icon small color="light-blue darken-4"
                  >mdi-map-marker-radius</v-icon
                >
                {{ item.location }}
              </span>
            </div>
            <div class="pt-4">
              <span>
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Night") }}</span>
              </span>
              <span class="ml-3">
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.weekly_price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Week") }}</span>
              </span>
              <span class="ml-3">
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.monthly_price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Month") }}</span>
              </span>
            </div>
            <div class="pt-4">
              <v-btn
                class="mr-2"
                color="grey"
                :to="{
                  name: 'PartnerListingViewComponent',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("ViewAndEdit") }}
              </v-btn>
              <v-btn
                v-if="item.contract"
                class="mr-2"
                color="light-blue"
                :to="{
                  name: 'PartnerContractComponent',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("EditContract") }}
              </v-btn>
              <v-btn
                v-else
                class="mr-2"
                color="light-blue"
                @click="buildContract(item._id)"
                dark
                >{{ $t("BuildContract") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="archivedListings.length" class="pl-3">
        <h2 class="text-h5 mb-5 mt-5">
          {{ $t("Archivedlist") }}
        </h2>
        <v-row
          class="elevation-2 mb-2 red lighten-4"
          v-for="item in archivedListings"
          :key="item._id"
        >
          <v-col cols="3">
            <v-skeleton-loader
              v-if="!item.pictures.length"
              class="mx-auto"
              type="image"
              height="180"
            ></v-skeleton-loader>
            <v-carousel
              show-arrows-on-hover
              hide-delimiters
              class
              height="180"
              v-if="item.pictures.length"
            >
              <v-carousel-item
                v-for="(items, i) in item.pictures"
                :key="i"
                :src="
                  $store.state.baseUrl +
                    'listing/thumb320x240-' +
                    items.file_name
                "
              ></v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col>
            <div class="pb-2">
              <v-chip small class="mr-2 red darken-3" text-color="white">
                {{ $t("Archived") }}
              </v-chip>
              <v-chip small class="mr-2" color="yellow">
                {{ $t("Created") }} :
                {{ format(new Date(item.dateCreated), "MM/dd/yyyy") }}
              </v-chip>
            </div>
            <div class="text-h5">
              {{ item.name }}
            </div>
            <div class="subtitle-1 pt-1 text-capitalize">
              <span>
                <v-icon small color="light-blue darken-4"
                  >mdi-map-marker-radius</v-icon
                >
                {{ item.location }}
              </span>
            </div>
            <div class="pt-4">
              <span>
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Night") }}</span>
              </span>
              <span class="ml-3">
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.weekly_price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Week") }}</span>
              </span>
              <span class="ml-3">
                <span class="subtitle-2 grey--text"
                  >{{ item.currency_code }}
                </span>
                <span
                  class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                  >{{ item.monthly_price }}
                </span>
                <span class="subtitle-2 grey--text"> / {{ $t("Month") }}</span>
              </span>
            </div>
            <div class="pt-4">
              <v-btn
                class="mr-2"
                color="grey"
                :to="{
                  name: 'PartnerListingViewComponent',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("ViewAndEdit") }}
              </v-btn>
              <v-btn
                v-if="item.contract"
                class="mr-2"
                color="light-blue"
                :to="{
                  name: 'PartnerContractComponent',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("EditContract") }}
              </v-btn>
              <v-btn
                v-else
                class="mr-2"
                color="light-blue"
                @click="buildContract(item._id)"
                dark
                >{{ $t("BuildContract") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </div>
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import ListingService from "@/services/ListingService";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import PartnerService from "@/services/PartnerService";
import { format } from "date-fns";

export default {
  name: "ListingsComponent",
  mixins: [timeoutMixin],
  components: { WaitDialogComponent },
  data() {
    return {
      format,
      loading: true,
      listProperty: [],
      archivedListings: [],
      error: null,
      waitDialog: false
    };
  },
  beforeCreate: function() {
    ListingService.listProperties({})
      .then(result => {
        this.listProperty = this.sortPictureOrder(result.data.item.publicList);
        this.archivedListings = this.sortPictureOrder(
          result.data.item.archivedList
        );
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    sortPictureOrder(item) {
      const resultList = item.map(property => {
        let { pictures } = property;
        pictures.sort((a, b) => a.order - b.order);
        return { ...property, pictures };
      });
      return resultList;
    },
    buildContract(val) {
      this.waitDilog = true;
      PartnerService.createContract({
        title: "General Lease Agreement",
        description:
          "This Commercial Lease Agreement is made and effective March 01, 2017, by and between Landlord and Tenant.",
        property_id: val
      })
        .then(result => {
          this.waitDialog = false;
          this.$router.push({
            name: "PartnerContractComponent",
            params: { id: result.data.contract.property_id }
          });
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.errors;
        });
    }
  }
};
</script>

<style></style>
